<template>
    <transition name="fade">
        <div v-show="isOpen" @mousedown="$emit('close')" class="Modal">
            <div class="Modal__wrapper">
                <slot/>
            </div>
        </div>
    </transition>
</template>

<script>
    export default {
        props: {
            isOpen: Boolean
        },
        watch: {
            isOpen: function () {
                this.lockScroll()
            }
        },
        methods: {
            handleKeyup(e) {
                if (e.keyCode === 27) this.$emit('close');
            },
            lockScroll: function () {
                if (this.isOpen) {
                    document.body.style.top = `-${window.scrollY}px`;
                    document.body.style.position = 'fixed';
                } else {
                    const scrollY = document.body.style.top;
                    document.body.style.position = '';
                    document.body.style.top = '';
                    window.scrollTo(0, parseInt(scrollY || '0') * -1);
                }
            }
        },
        created() {
            this.lockScroll();
            document.addEventListener('keyup', this.handleKeyup);
        },
        beforeDestroy() {
            document.removeEventListener('keyup', this.handleKeyup);
        }
    }
</script>

<style scoped>
    .fade-enter-active, .fade-leave-active {
        transition: 0.5s;
    }

    .fade-enter, .fade-leave-to {
        opacity: 0;
    }

    .fade-enter .Modal__wrapper, .fade-leave-to .Modal__wrapper {
        transform: translateY(-20%);
    }

    .Modal__wrapper {
        transition: 0.5s;
    }
</style>
